import { cn } from '@/lib/utils'
import { useEditorStore } from 'CanvasCore/uiSlice'
import { color2Linear } from 'CanvasCore/utils'
import { ColorCard } from 'components/ui/ColorCard'
import React, { useMemo } from 'react'
import { useParams } from 'react-router-dom'

const useSelectedColor = (tid, toningId, lid) => {
  const tonings = useEditorStore((state) => state.editors[tid]?.tonings)
  const selectedColor = useMemo(() => {
    return tonings?.[toningId]?.[lid]
  }, [tonings, toningId, lid])

  return selectedColor
}

const useSelected = (tid, toningId, id) => {
  const selectedColor = useSelectedColor(tid, toningId, 'default')
  return selectedColor?.id === id
}

const LinearColor = ({ toningId, color }) => {
  const { tid } = useParams()
  const { id, colors } = color

  const linear = useMemo(() => color2Linear(colors), [colors])

  const selected = useSelected(tid, toningId, color.id)

  const selectColor = useEditorStore((state) => state.selectColor)
  const deselectColor = useEditorStore((state) => state.deselectColor)

  const handleClick = () => {
    if (selected) {
      //unselected
      deselectColor(tid, toningId)
    } else {
      selectColor(tid, toningId, 'default', { id, color: linear })
    }
  }
  if (!color || !linear) {
    return null
  }
  return (
    <ColorCard
      onClick={handleClick}
      className={cn(
        'border-transparent',
        selected && 'border-2 border-primary',
      )}
    >
      <div
        className="rounded-lg w-5/6 h-5/6"
        style={{ backgroundImage: linear }}
        onClick={handleClick}
      />
    </ColorCard>
  )
}

export default LinearColor
